import '../App.css';
import Sidebar from '../components/Sidebar';
import '../styles/login.css'
import { withRouter } from "react-router-dom"
function Administracion(props) {

  return (
    <div className="App">
      <Sidebar tipo="2"></Sidebar>
      <br />
      <h1>Administracion</h1>
    </div>
  );
}

export default withRouter(Administracion);
